// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/root/workspace/ccrc-health-management_Ligp/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@ant-design/pro-layout/es/PageLoading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 't__plugin-layout__Layout' */'/root/workspace/ccrc-health-management_Ligp/src/.umi-production/plugin-layout/Layout.tsx'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/404",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'@/pages/404.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ActivityManage/ActivityList/SignupRecords",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ActivityManage__ActivityList__SignupRecords__index' */'@/pages/ActivityManage/ActivityList/SignupRecords/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ActivityManage/ActivityList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ActivityManage__ActivityList__index' */'@/pages/ActivityManage/ActivityList/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ActivityManage/ActivityModification",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ActivityManage__ActivityModification__index' */'@/pages/ActivityManage/ActivityModification/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Admin",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Admin' */'@/pages/Admin.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Assessment/Records/AnswerModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Assessment__Records__AnswerModal__index' */'@/pages/Assessment/Records/AnswerModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Assessment/Records/ChooseQuestionnaireModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Assessment__Records__ChooseQuestionnaireModal__index' */'@/pages/Assessment/Records/ChooseQuestionnaireModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Assessment/Records/ReportModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Assessment__Records__ReportModal__index' */'@/pages/Assessment/Records/ReportModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Assessment/Records",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Assessment__Records__index' */'@/pages/Assessment/Records/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Assessment/ReportDetail/PhysiqueDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Assessment__ReportDetail__PhysiqueDetail' */'@/pages/Assessment/ReportDetail/PhysiqueDetail.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/Assessment/ReportDetail/RiskDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Assessment__ReportDetail__RiskDetail' */'@/pages/Assessment/ReportDetail/RiskDetail.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/Assessment/ReportDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Assessment__ReportDetail__index' */'@/pages/Assessment/ReportDetail/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/ContentManage/Food",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__Food__index' */'@/pages/ContentManage/Food/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/FoodPlanUpdate/Components/CalcMealNutrient",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__FoodPlanUpdate__Components__CalcMealNutrient__index' */'@/pages/ContentManage/FoodPlanUpdate/Components/CalcMealNutrient/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/FoodPlanUpdate/Components/ChooseDishesModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__FoodPlanUpdate__Components__ChooseDishesModal__index' */'@/pages/ContentManage/FoodPlanUpdate/Components/ChooseDishesModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/FoodPlanUpdate/Components/CollapseDishes",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__FoodPlanUpdate__Components__CollapseDishes__index' */'@/pages/ContentManage/FoodPlanUpdate/Components/CollapseDishes/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/FoodPlanUpdate/Components/EChartDiv",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__FoodPlanUpdate__Components__EChartDiv__index' */'@/pages/ContentManage/FoodPlanUpdate/Components/EChartDiv/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/FoodPlanUpdate/Components/EditContentFoodGroup",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__FoodPlanUpdate__Components__EditContentFoodGroup__index' */'@/pages/ContentManage/FoodPlanUpdate/Components/EditContentFoodGroup/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/FoodPlanUpdate/Components/NurientAnalysisModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__FoodPlanUpdate__Components__NurientAnalysisModal__index' */'@/pages/ContentManage/FoodPlanUpdate/Components/NurientAnalysisModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/FoodPlanUpdate/Components/RightCard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__FoodPlanUpdate__Components__RightCard__index' */'@/pages/ContentManage/FoodPlanUpdate/Components/RightCard/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/FoodPlanUpdate/Components/TemplateTable",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__FoodPlanUpdate__Components__TemplateTable__index' */'@/pages/ContentManage/FoodPlanUpdate/Components/TemplateTable/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/FoodPlanUpdate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__FoodPlanUpdate__index' */'@/pages/ContentManage/FoodPlanUpdate/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/FoodPrinciple",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__FoodPrinciple__index' */'@/pages/ContentManage/FoodPrinciple/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/Intervention",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__Intervention__index' */'@/pages/ContentManage/Intervention/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/InterventionUpdate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__InterventionUpdate__index' */'@/pages/ContentManage/InterventionUpdate/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/InterventionView",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__InterventionView__index' */'@/pages/ContentManage/InterventionView/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/ContentManage/Medicine/UpdateMedicine",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__Medicine__UpdateMedicine__index' */'@/pages/ContentManage/Medicine/UpdateMedicine/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/Medicine",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__Medicine__index' */'@/pages/ContentManage/Medicine/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/ReturnVisit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__ReturnVisit__index' */'@/pages/ContentManage/ReturnVisit/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/ReturnVisitUpdate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__ReturnVisitUpdate__index' */'@/pages/ContentManage/ReturnVisitUpdate/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/ServicePlan",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__ServicePlan__index' */'@/pages/ContentManage/ServicePlan/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/ServicePlanUpdate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__ServicePlanUpdate__index' */'@/pages/ContentManage/ServicePlanUpdate/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/SmsTemplate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__SmsTemplate__index' */'@/pages/ContentManage/SmsTemplate/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/SportPlan",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__SportPlan__index' */'@/pages/ContentManage/SportPlan/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/SportPlanUpdate/EditSportGroup",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__SportPlanUpdate__EditSportGroup' */'@/pages/ContentManage/SportPlanUpdate/EditSportGroup.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ContentManage/SportPlanUpdate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ContentManage__SportPlanUpdate__index' */'@/pages/ContentManage/SportPlanUpdate/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/AddCustomer",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__AddCustomer__index' */'@/pages/Customer/AddCustomer/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/AssessReportDetail/PhysiqueDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__AssessReportDetail__PhysiqueDetail' */'@/pages/Customer/AssessReportDetail/PhysiqueDetail.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/Customer/AssessReportDetail/RiskDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__AssessReportDetail__RiskDetail' */'@/pages/Customer/AssessReportDetail/RiskDetail.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/Customer/AssessReportDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__AssessReportDetail__index' */'@/pages/Customer/AssessReportDetail/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/Customer/Community",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__Community__index' */'@/pages/Customer/Community/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/CustomerDetail/V2",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__CustomerDetail__V2__index' */'@/pages/Customer/CustomerDetail/V2/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/CustomerDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__CustomerDetail__index' */'@/pages/Customer/CustomerDetail/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/CustomerPackage/SignleBindPackageModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__CustomerPackage__SignleBindPackageModal__index' */'@/pages/Customer/CustomerPackage/SignleBindPackageModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/CustomerPackage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__CustomerPackage__index' */'@/pages/Customer/CustomerPackage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/Enterprise",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__Enterprise__index' */'@/pages/Customer/Enterprise/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/ExamRecords/DataModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__ExamRecords__DataModal__index' */'@/pages/Customer/ExamRecords/DataModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/ExamRecords/LookHHData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__ExamRecords__LookHHData__index' */'@/pages/Customer/ExamRecords/LookHHData/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/ExamRecords/LookHHReport",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__ExamRecords__LookHHReport__index' */'@/pages/Customer/ExamRecords/LookHHReport/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/ExamRecords/UserExamRecord/RecordModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__ExamRecords__UserExamRecord__RecordModal__index' */'@/pages/Customer/ExamRecords/UserExamRecord/RecordModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/ExamRecords/UserExamRecord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__ExamRecords__UserExamRecord__index' */'@/pages/Customer/ExamRecords/UserExamRecord/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/Customer/ExamRecords",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__ExamRecords__index' */'@/pages/Customer/ExamRecords/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/GoodsBilling/features/FunctionalMedicineBilling",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__GoodsBilling__features__FunctionalMedicineBilling__index' */'@/pages/Customer/GoodsBilling/features/FunctionalMedicineBilling/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/GoodsBilling/features/InjectionBilling",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__GoodsBilling__features__InjectionBilling__index' */'@/pages/Customer/GoodsBilling/features/InjectionBilling/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/GoodsBilling/features/NutrimentBilling",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__GoodsBilling__features__NutrimentBilling__index' */'@/pages/Customer/GoodsBilling/features/NutrimentBilling/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/GoodsBilling/features/OralAdministrationBilling",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__GoodsBilling__features__OralAdministrationBilling__index' */'@/pages/Customer/GoodsBilling/features/OralAdministrationBilling/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/GoodsBilling/hooks/useFormBilling",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__GoodsBilling__hooks__useFormBilling' */'@/pages/Customer/GoodsBilling/hooks/useFormBilling.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/GoodsBilling",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__GoodsBilling__index' */'@/pages/Customer/GoodsBilling/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/GoodsBilling/pdfStyles/functionalMedicineStyle",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__GoodsBilling__pdfStyles__functionalMedicineStyle__index' */'@/pages/Customer/GoodsBilling/pdfStyles/functionalMedicineStyle/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/GoodsBilling/pdfStyles/injectionStyle",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__GoodsBilling__pdfStyles__injectionStyle__index' */'@/pages/Customer/GoodsBilling/pdfStyles/injectionStyle/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/GoodsBilling/pdfStyles/nutrimentStyle",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__GoodsBilling__pdfStyles__nutrimentStyle__index' */'@/pages/Customer/GoodsBilling/pdfStyles/nutrimentStyle/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/GoodsBilling/pdfStyles/oralAdministrationStyle",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__GoodsBilling__pdfStyles__oralAdministrationStyle__index' */'@/pages/Customer/GoodsBilling/pdfStyles/oralAdministrationStyle/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/GoodsBilling/pdfStyles/pay",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__GoodsBilling__pdfStyles__pay' */'@/pages/Customer/GoodsBilling/pdfStyles/pay.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/GroupReport",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__GroupReport__index' */'@/pages/Customer/GroupReport/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/GroupReportDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__GroupReportDetail__index' */'@/pages/Customer/GroupReportDetail/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/Customer/HealthReport",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__HealthReport__index' */'@/pages/Customer/HealthReport/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/HealthReportView",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__HealthReportView__index' */'@/pages/Customer/HealthReportView/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/Customer/LabelManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__LabelManage__index' */'@/pages/Customer/LabelManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/LevelManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__LevelManage__index' */'@/pages/Customer/LevelManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/MessageBoard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__MessageBoard__index' */'@/pages/Customer/MessageBoard/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/MyCustomer",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__MyCustomer__index' */'@/pages/Customer/MyCustomer/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/OrgCustomer",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__OrgCustomer__index' */'@/pages/Customer/OrgCustomer/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/PersonalHealthReport",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__PersonalHealthReport__index' */'@/pages/Customer/PersonalHealthReport/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/PersonalHealthReportDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__PersonalHealthReportDetail__index' */'@/pages/Customer/PersonalHealthReportDetail/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/Customer/PublicCustomer",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__PublicCustomer__index' */'@/pages/Customer/PublicCustomer/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/Records/AnswerModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__Records__AnswerModal__index' */'@/pages/Customer/Records/AnswerModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/Records/ChooseQuestionnaireModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__Records__ChooseQuestionnaireModal__index' */'@/pages/Customer/Records/ChooseQuestionnaireModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/Records/ReportModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__Records__ReportModal__index' */'@/pages/Customer/Records/ReportModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/Records",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__Records__index' */'@/pages/Customer/Records/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/ReportA4Detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__ReportA4Detail__index' */'@/pages/Customer/ReportA4Detail/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/Customer/ReportDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__ReportDetail__index' */'@/pages/Customer/ReportDetail/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/Customer/ReportList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__ReportList__index' */'@/pages/Customer/ReportList/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/ReportUpload",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__ReportUpload__index' */'@/pages/Customer/ReportUpload/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/Satisfaction",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__Satisfaction__index' */'@/pages/Customer/Satisfaction/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/ServiceCustomer",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__ServiceCustomer__index' */'@/pages/Customer/ServiceCustomer/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TeamManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TeamManage__index' */'@/pages/Customer/TeamManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/AdviceBox",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__AdviceBox__index' */'@/pages/Customer/TestReport/AdviceBox/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/Arteriosclerosis",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__Arteriosclerosis__index' */'@/pages/Customer/TestReport/Arteriosclerosis/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/BMI",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__BMI__index' */'@/pages/Customer/TestReport/BMI/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/BloodPressure",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__BloodPressure__index' */'@/pages/Customer/TestReport/BloodPressure/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/BodyComposition",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__BodyComposition__index' */'@/pages/Customer/TestReport/BodyComposition/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/BodyStatus",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__BodyStatus__index' */'@/pages/Customer/TestReport/BodyStatus/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/BoneDensity",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__BoneDensity__index' */'@/pages/Customer/TestReport/BoneDensity/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/ECG",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__ECG__index' */'@/pages/Customer/TestReport/ECG/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/Electrocardiography",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__Electrocardiography__index' */'@/pages/Customer/TestReport/Electrocardiography/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/FrontCover",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__FrontCover__index' */'@/pages/Customer/TestReport/FrontCover/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/Glu",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__Glu__index' */'@/pages/Customer/TestReport/Glu/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/Label",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__Label__index' */'@/pages/Customer/TestReport/Label/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/LungFunction",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__LungFunction__index' */'@/pages/Customer/TestReport/LungFunction/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/PersonalData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__PersonalData__index' */'@/pages/Customer/TestReport/PersonalData/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/PhysicalIndicators",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__PhysicalIndicators__index' */'@/pages/Customer/TestReport/PhysicalIndicators/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/ReportTable",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__ReportTable__index' */'@/pages/Customer/TestReport/ReportTable/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/TotalCholesterol",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__TotalCholesterol__index' */'@/pages/Customer/TestReport/TotalCholesterol/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/Urine",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__Urine__index' */'@/pages/Customer/TestReport/Urine/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/bloodLipids",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__bloodLipids__index' */'@/pages/Customer/TestReport/bloodLipids/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport/dataBox",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__dataBox__index' */'@/pages/Customer/TestReport/dataBox/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/TestReport",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__index' */'@/pages/Customer/TestReport/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/Customer/TestReport/uricAcid",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__TestReport__uricAcid__index' */'@/pages/Customer/TestReport/uricAcid/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Customer/ZhaiKer",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Customer__ZhaiKer__index' */'@/pages/Customer/ZhaiKer/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/CustomerStatistics/Customer",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__CustomerStatistics__Customer__index' */'@/pages/CustomerStatistics/Customer/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentDetail/conponents/Details",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentDetail__conponents__Details__index' */'@/pages/EquipmentManagement/EquipmentDetail/conponents/Details/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentDetail/conponents/Measurement/MeterLog",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentDetail__conponents__Measurement__MeterLog__index' */'@/pages/EquipmentManagement/EquipmentDetail/conponents/Measurement/MeterLog/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentDetail/conponents/Measurement/MeterMeasurement/UpdateModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentDetail__conponents__Measurement__MeterMeasurement__UpdateModal__index' */'@/pages/EquipmentManagement/EquipmentDetail/conponents/Measurement/MeterMeasurement/UpdateModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentDetail/conponents/Measurement/MeterMeasurement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentDetail__conponents__Measurement__MeterMeasurement__index' */'@/pages/EquipmentManagement/EquipmentDetail/conponents/Measurement/MeterMeasurement/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentDetail/conponents/Measurement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentDetail__conponents__Measurement__index' */'@/pages/EquipmentManagement/EquipmentDetail/conponents/Measurement/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentDetail/conponents/WristWatch/AlarmLog",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentDetail__conponents__WristWatch__AlarmLog__index' */'@/pages/EquipmentManagement/EquipmentDetail/conponents/WristWatch/AlarmLog/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentDetail/conponents/WristWatch/Map",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentDetail__conponents__WristWatch__Map__index' */'@/pages/EquipmentManagement/EquipmentDetail/conponents/WristWatch/Map/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentDetail/conponents/WristWatch/MeterMeasurement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentDetail__conponents__WristWatch__MeterMeasurement__index' */'@/pages/EquipmentManagement/EquipmentDetail/conponents/WristWatch/MeterMeasurement/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentDetail/conponents/WristWatch/PositionTrack",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentDetail__conponents__WristWatch__PositionTrack__index' */'@/pages/EquipmentManagement/EquipmentDetail/conponents/WristWatch/PositionTrack/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentDetail/conponents/WristWatch",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentDetail__conponents__WristWatch__index' */'@/pages/EquipmentManagement/EquipmentDetail/conponents/WristWatch/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentDetail__index' */'@/pages/EquipmentManagement/EquipmentDetail/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentRegister/Meters",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentRegister__Meters__index' */'@/pages/EquipmentManagement/EquipmentRegister/Meters/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentRegister/Registration",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentRegister__Registration__index' */'@/pages/EquipmentManagement/EquipmentRegister/Registration/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentRegister/RegistrationList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentRegister__RegistrationList__index' */'@/pages/EquipmentManagement/EquipmentRegister/RegistrationList/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentRegister",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentRegister__index' */'@/pages/EquipmentManagement/EquipmentRegister/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/EquipmentManagement/EquipmentView",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__EquipmentManagement__EquipmentView__index' */'@/pages/EquipmentManagement/EquipmentView/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/AddHut",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__AddHut__index' */'@/pages/HutManage/AddHut/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/ExamRecords/DataModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__ExamRecords__DataModal__index' */'@/pages/HutManage/ExamRecords/DataModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/ExamRecords/LookHHData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__ExamRecords__LookHHData__index' */'@/pages/HutManage/ExamRecords/LookHHData/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/ExamRecords/LookHHReport",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__ExamRecords__LookHHReport__index' */'@/pages/HutManage/ExamRecords/LookHHReport/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/ExamRecords/UserExamRecord/RecordModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__ExamRecords__UserExamRecord__RecordModal__index' */'@/pages/HutManage/ExamRecords/UserExamRecord/RecordModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/ExamRecords/UserExamRecord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__ExamRecords__UserExamRecord__index' */'@/pages/HutManage/ExamRecords/UserExamRecord/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/HutManage/ExamRecords",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__ExamRecords__index' */'@/pages/HutManage/ExamRecords/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/Manage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__Manage__index' */'@/pages/HutManage/Manage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/AdviceBox",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__AdviceBox__index' */'@/pages/HutManage/TestReport/AdviceBox/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/Arteriosclerosis",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__Arteriosclerosis__index' */'@/pages/HutManage/TestReport/Arteriosclerosis/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/BMI",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__BMI__index' */'@/pages/HutManage/TestReport/BMI/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/BloodPressure",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__BloodPressure__index' */'@/pages/HutManage/TestReport/BloodPressure/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/BodyComposition",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__BodyComposition__index' */'@/pages/HutManage/TestReport/BodyComposition/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/BodyStatus",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__BodyStatus__index' */'@/pages/HutManage/TestReport/BodyStatus/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/BoneDensity",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__BoneDensity__index' */'@/pages/HutManage/TestReport/BoneDensity/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/ECG",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__ECG__index' */'@/pages/HutManage/TestReport/ECG/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/Electrocardiography",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__Electrocardiography__index' */'@/pages/HutManage/TestReport/Electrocardiography/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/FrontCover",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__FrontCover__index' */'@/pages/HutManage/TestReport/FrontCover/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/Glu",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__Glu__index' */'@/pages/HutManage/TestReport/Glu/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/Label",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__Label__index' */'@/pages/HutManage/TestReport/Label/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/LungFunction",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__LungFunction__index' */'@/pages/HutManage/TestReport/LungFunction/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/PersonalData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__PersonalData__index' */'@/pages/HutManage/TestReport/PersonalData/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/PhysicalIndicators",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__PhysicalIndicators__index' */'@/pages/HutManage/TestReport/PhysicalIndicators/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/ReportTable",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__ReportTable__index' */'@/pages/HutManage/TestReport/ReportTable/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/TotalCholesterol",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__TotalCholesterol__index' */'@/pages/HutManage/TestReport/TotalCholesterol/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/Urine",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__Urine__index' */'@/pages/HutManage/TestReport/Urine/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/bloodLipids",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__bloodLipids__index' */'@/pages/HutManage/TestReport/bloodLipids/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport/dataBox",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__dataBox__index' */'@/pages/HutManage/TestReport/dataBox/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/TestReport",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__index' */'@/pages/HutManage/TestReport/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/HutManage/TestReport/uricAcid",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__TestReport__uricAcid__index' */'@/pages/HutManage/TestReport/uricAcid/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/HutManage/ZhaiKer",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__HutManage__ZhaiKer__index' */'@/pages/HutManage/ZhaiKer/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/Inquiry/InquiryHistory",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Inquiry__InquiryHistory__index' */'@/pages/Inquiry/InquiryHistory/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Inquiry/Online",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Inquiry__Online__index' */'@/pages/Inquiry/Online/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Inquiry/Schedule",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Inquiry__Schedule__index' */'@/pages/Inquiry/Schedule/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Inquiry/Service",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Inquiry__Service__index' */'@/pages/Inquiry/Service/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/MemberPoint/PointRecord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MemberPoint__PointRecord__index' */'@/pages/MemberPoint/PointRecord/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/MemberPoint/Setting",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MemberPoint__Setting__index' */'@/pages/MemberPoint/Setting/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Messages",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Messages__index' */'@/pages/Messages/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OperationManage/EquipmentRegister/Meters",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperationManage__EquipmentRegister__Meters__index' */'@/pages/OperationManage/EquipmentRegister/Meters/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OperationManage/EquipmentRegister/Registration",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperationManage__EquipmentRegister__Registration__index' */'@/pages/OperationManage/EquipmentRegister/Registration/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OperationManage/EquipmentRegister/RegistrationList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperationManage__EquipmentRegister__RegistrationList__index' */'@/pages/OperationManage/EquipmentRegister/RegistrationList/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OperationManage/EquipmentRegister",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperationManage__EquipmentRegister__index' */'@/pages/OperationManage/EquipmentRegister/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OperationManage/EquipmentView",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperationManage__EquipmentView__index' */'@/pages/OperationManage/EquipmentView/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OperationManage/Information",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperationManage__Information__index' */'@/pages/OperationManage/Information/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OperationManage/InformationUpdate/AudioUploadTable",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperationManage__InformationUpdate__AudioUploadTable__index' */'@/pages/OperationManage/InformationUpdate/AudioUploadTable/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OperationManage/InformationUpdate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperationManage__InformationUpdate__index' */'@/pages/OperationManage/InformationUpdate/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OperationManage/MicroMedicalOrders/DetailListOrder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperationManage__MicroMedicalOrders__DetailListOrder__index' */'@/pages/OperationManage/MicroMedicalOrders/DetailListOrder/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OperationManage/MicroMedicalOrders/microOrderList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperationManage__MicroMedicalOrders__microOrderList__index' */'@/pages/OperationManage/MicroMedicalOrders/microOrderList/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OperationManage/PointRecord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperationManage__PointRecord__index' */'@/pages/OperationManage/PointRecord/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OperationManage/SmartPush/RuleSetting",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperationManage__SmartPush__RuleSetting__index' */'@/pages/OperationManage/SmartPush/RuleSetting/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OperationManage/SmartPush",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperationManage__SmartPush__index' */'@/pages/OperationManage/SmartPush/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OperationManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OperationManage__index' */'@/pages/OperationManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OrderAdministrate/CategoryAddEdit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OrderAdministrate__CategoryAddEdit__index' */'@/pages/OrderAdministrate/CategoryAddEdit/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OrderAdministrate/CategoryController",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OrderAdministrate__CategoryController__index' */'@/pages/OrderAdministrate/CategoryController/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OrderAdministrate/ItemController",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OrderAdministrate__ItemController__index' */'@/pages/OrderAdministrate/ItemController/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/OrderAdministrate/OrderForm",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OrderAdministrate__OrderForm__index' */'@/pages/OrderAdministrate/OrderForm/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/PhysicalManage/ReportList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PhysicalManage__ReportList__index' */'@/pages/PhysicalManage/ReportList/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/PhysicalManage/ReportUpload",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PhysicalManage__ReportUpload__index' */'@/pages/PhysicalManage/ReportUpload/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Process/FlowSheet",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Process__FlowSheet__index' */'@/pages/Process/FlowSheet/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/PublicAccount/OATemplateMessage/crowdUpdate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PublicAccount__OATemplateMessage__crowdUpdate' */'@/pages/PublicAccount/OATemplateMessage/crowdUpdate.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/PublicAccount/OATemplateMessage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PublicAccount__OATemplateMessage__index' */'@/pages/PublicAccount/OATemplateMessage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/PublicAccount/OATemplateMessage/update",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PublicAccount__OATemplateMessage__update' */'@/pages/PublicAccount/OATemplateMessage/update.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/PublicAccount/PublicAccountMessage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PublicAccount__PublicAccountMessage__index' */'@/pages/PublicAccount/PublicAccountMessage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Service/BindRecords",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Service__BindRecords__index' */'@/pages/Service/BindRecords/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Service/HealthInterventionModel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Service__HealthInterventionModel__index' */'@/pages/Service/HealthInterventionModel/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Service/PackageAdd",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Service__PackageAdd__index' */'@/pages/Service/PackageAdd/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Service/PackageManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Service__PackageManage__index' */'@/pages/Service/PackageManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Service/PersonalHealthReport",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Service__PersonalHealthReport__index' */'@/pages/Service/PersonalHealthReport/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Service/ServiceRecordCreate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Service__ServiceRecordCreate__index' */'@/pages/Service/ServiceRecordCreate/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/Service/ServiceUpdate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Service__ServiceUpdate__index' */'@/pages/Service/ServiceUpdate/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Service/Services",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Service__Services__index' */'@/pages/Service/Services/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ServiceManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ServiceManage__index' */'@/pages/ServiceManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SettingService/BindRecords",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SettingService__BindRecords__index' */'@/pages/SettingService/BindRecords/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SettingService/HealthInterventionModel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SettingService__HealthInterventionModel__index' */'@/pages/SettingService/HealthInterventionModel/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SettingService/LevelManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SettingService__LevelManage__index' */'@/pages/SettingService/LevelManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SettingService/PackageAdd",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SettingService__PackageAdd__index' */'@/pages/SettingService/PackageAdd/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SettingService/PackageManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SettingService__PackageManage__index' */'@/pages/SettingService/PackageManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SettingService/PersonalHealthReport",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SettingService__PersonalHealthReport__index' */'@/pages/SettingService/PersonalHealthReport/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SettingService/ServiceUpdate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SettingService__ServiceUpdate__index' */'@/pages/SettingService/ServiceUpdate/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SettingService/Services",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SettingService__Services__index' */'@/pages/SettingService/Services/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SettingService/TeamManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SettingService__TeamManage__index' */'@/pages/SettingService/TeamManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Settings",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Settings__index' */'@/pages/Settings/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/CategoryAddEdit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__CategoryAddEdit__index' */'@/pages/ShoppingManage/CategoryAddEdit/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/CategoryController",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__CategoryController__index' */'@/pages/ShoppingManage/CategoryController/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/CategoryManger",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__CategoryManger__index' */'@/pages/ShoppingManage/CategoryManger/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/CommodityManger",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__CommodityManger__index' */'@/pages/ShoppingManage/CommodityManger/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/CommodityOptions",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__CommodityOptions__index' */'@/pages/ShoppingManage/CommodityOptions/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/Consumables/Edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__Consumables__Edit__index' */'@/pages/ShoppingManage/Consumables/Edit/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/Consumables",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__Consumables__index' */'@/pages/ShoppingManage/Consumables/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/DetailListOrder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__DetailListOrder__index' */'@/pages/ShoppingManage/DetailListOrder/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/GoodsOrders/FunctionalMedicineOrder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__GoodsOrders__FunctionalMedicineOrder' */'@/pages/ShoppingManage/GoodsOrders/FunctionalMedicineOrder.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/GoodsOrders/InjectionOrder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__GoodsOrders__InjectionOrder' */'@/pages/ShoppingManage/GoodsOrders/InjectionOrder.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/GoodsOrders/NutrimentOrder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__GoodsOrders__NutrimentOrder' */'@/pages/ShoppingManage/GoodsOrders/NutrimentOrder.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/GoodsOrders/OralOrder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__GoodsOrders__OralOrder' */'@/pages/ShoppingManage/GoodsOrders/OralOrder.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/GoodsOrders/hooks/useColumnInOrderRefund",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__GoodsOrders__hooks__useColumnInOrderRefund' */'@/pages/ShoppingManage/GoodsOrders/hooks/useColumnInOrderRefund.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/GoodsOrders/hooks/useListExpandedTable",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__GoodsOrders__hooks__useListExpandedTable' */'@/pages/ShoppingManage/GoodsOrders/hooks/useListExpandedTable.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/GoodsOrders/hooks/useTableInClosableOrder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__GoodsOrders__hooks__useTableInClosableOrder' */'@/pages/ShoppingManage/GoodsOrders/hooks/useTableInClosableOrder.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/GoodsOrders",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__GoodsOrders__index' */'@/pages/ShoppingManage/GoodsOrders/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/Inquiry",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__Inquiry__index' */'@/pages/ShoppingManage/Inquiry/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/InspectionItems/Edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__InspectionItems__Edit__index' */'@/pages/ShoppingManage/InspectionItems/Edit/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/InspectionItems",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__InspectionItems__index' */'@/pages/ShoppingManage/InspectionItems/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/ItemController",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__ItemController__index' */'@/pages/ShoppingManage/ItemController/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/MallCreate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__MallCreate__index' */'@/pages/ShoppingManage/MallCreate/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/MallFreight",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__MallFreight__index' */'@/pages/ShoppingManage/MallFreight/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/MallShop",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__MallShop__index' */'@/pages/ShoppingManage/MallShop/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/Medication/Edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__Medication__Edit__index' */'@/pages/ShoppingManage/Medication/Edit/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/Medication/EditTemplate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__Medication__EditTemplate__index' */'@/pages/ShoppingManage/Medication/EditTemplate/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/Medication",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__Medication__index' */'@/pages/ShoppingManage/Medication/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/MicroMedicalOrders/DetailListOrder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__MicroMedicalOrders__DetailListOrder__index' */'@/pages/ShoppingManage/MicroMedicalOrders/DetailListOrder/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/MicroMedicalOrders/microOrderList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__MicroMedicalOrders__microOrderList__index' */'@/pages/ShoppingManage/MicroMedicalOrders/microOrderList/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/OrderForm",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__OrderForm__index' */'@/pages/ShoppingManage/OrderForm/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/OrderManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__OrderManage__index' */'@/pages/ShoppingManage/OrderManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/PromoteOrder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__PromoteOrder__index' */'@/pages/ShoppingManage/PromoteOrder/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/Promotion/PromotionStatus",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__Promotion__PromotionStatus__index' */'@/pages/ShoppingManage/Promotion/PromotionStatus/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/Promotion",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__Promotion__index' */'@/pages/ShoppingManage/Promotion/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/PromotionAdd/GoodsAddModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__PromotionAdd__GoodsAddModal__index' */'@/pages/ShoppingManage/PromotionAdd/GoodsAddModal/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/PromotionAdd/GoodsUpdateTable",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__PromotionAdd__GoodsUpdateTable__index' */'@/pages/ShoppingManage/PromotionAdd/GoodsUpdateTable/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/ShoppingManage/PromotionAdd",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ShoppingManage__PromotionAdd__index' */'@/pages/ShoppingManage/PromotionAdd/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SmsManage/SmsGroup/ClientList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SmsManage__SmsGroup__ClientList__index' */'@/pages/SmsManage/SmsGroup/ClientList/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SmsManage/SmsGroup/TemplateList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SmsManage__SmsGroup__TemplateList__index' */'@/pages/SmsManage/SmsGroup/TemplateList/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SmsManage/SmsGroup/UpdateGroupSend",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SmsManage__SmsGroup__UpdateGroupSend__index' */'@/pages/SmsManage/SmsGroup/UpdateGroupSend/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SmsManage/SmsGroup",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SmsManage__SmsGroup__index' */'@/pages/SmsManage/SmsGroup/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SmsManage/SmsQuery",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SmsManage__SmsQuery__index' */'@/pages/SmsManage/SmsQuery/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SmsManage/SmsRecord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SmsManage__SmsRecord__index' */'@/pages/SmsManage/SmsRecord/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Statistics/Customer",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Statistics__Customer__index' */'@/pages/Statistics/Customer/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Statistics/Service",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Statistics__Service__index' */'@/pages/Statistics/Service/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Statistics",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Statistics__index' */'@/pages/Statistics/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/System/EmployerManage/AuthSetting",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__System__EmployerManage__AuthSetting__index' */'@/pages/System/EmployerManage/AuthSetting/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/System/EmployerManage/InfoForm",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__System__EmployerManage__InfoForm__index' */'@/pages/System/EmployerManage/InfoForm/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/System/EmployerManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__System__EmployerManage__index' */'@/pages/System/EmployerManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/System/OrgManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__System__OrgManage__index' */'@/pages/System/OrgManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/System/RoleAdd",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__System__RoleAdd__index' */'@/pages/System/RoleAdd/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/System/RoleManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__System__RoleManage__index' */'@/pages/System/RoleManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SystemNotification/Announcement/AdministratorList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SystemNotification__Announcement__AdministratorList__index' */'@/pages/SystemNotification/Announcement/AdministratorList/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SystemNotification/Announcement/UpdateAnnouncementSend",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SystemNotification__Announcement__UpdateAnnouncementSend__index' */'@/pages/SystemNotification/Announcement/UpdateAnnouncementSend/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SystemNotification/Announcement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SystemNotification__Announcement__index' */'@/pages/SystemNotification/Announcement/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SystemNotification/Notice",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SystemNotification__Notice__index' */'@/pages/SystemNotification/Notice/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SystemSettings/EmployerManage/AuthSetting",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SystemSettings__EmployerManage__AuthSetting__index' */'@/pages/SystemSettings/EmployerManage/AuthSetting/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SystemSettings/EmployerManage/InfoForm",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SystemSettings__EmployerManage__InfoForm__index' */'@/pages/SystemSettings/EmployerManage/InfoForm/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SystemSettings/EmployerManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SystemSettings__EmployerManage__index' */'@/pages/SystemSettings/EmployerManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SystemSettings/RoleAdd",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SystemSettings__RoleAdd__index' */'@/pages/SystemSettings/RoleAdd/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/SystemSettings/RoleManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SystemSettings__RoleManage__index' */'@/pages/SystemSettings/RoleManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TableList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TableList__index' */'@/pages/TableList/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TaskView/AllTasks",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TaskView__AllTasks__index' */'@/pages/TaskView/AllTasks/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TaskView/BatchCreateTask",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TaskView__BatchCreateTask__index' */'@/pages/TaskView/BatchCreateTask/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TaskView/ICreated",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TaskView__ICreated__index' */'@/pages/TaskView/ICreated/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TaskView/IProcess",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TaskView__IProcess__index' */'@/pages/TaskView/IProcess/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TaskView/ITransfer",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TaskView__ITransfer__index' */'@/pages/TaskView/ITransfer/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TaskView/MyTaskView",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TaskView__MyTaskView__index' */'@/pages/TaskView/MyTaskView/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TaskView/Mycustomer",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TaskView__Mycustomer__index' */'@/pages/TaskView/Mycustomer/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TaskView/Overview",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TaskView__Overview__index' */'@/pages/TaskView/Overview/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TaskView/TaskPrint",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TaskView__TaskPrint__index' */'@/pages/TaskView/TaskPrint/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/TaskView/TaskProcess",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TaskView__TaskProcess__index' */'@/pages/TaskView/TaskProcess/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TaskView/TaskProcessDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TaskView__TaskProcessDetail__index' */'@/pages/TaskView/TaskProcessDetail/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage/componentList/AddComponent/Client",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__componentList__AddComponent__Client__index' */'@/pages/TenantSettings/CustomizePage/componentList/AddComponent/Client/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage/componentList/AddComponent",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__componentList__AddComponent__index' */'@/pages/TenantSettings/CustomizePage/componentList/AddComponent/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage/componentList/ButtonComponent/Client",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__componentList__ButtonComponent__Client__index' */'@/pages/TenantSettings/CustomizePage/componentList/ButtonComponent/Client/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage/componentList/ButtonComponent/Tool",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__componentList__ButtonComponent__Tool__index' */'@/pages/TenantSettings/CustomizePage/componentList/ButtonComponent/Tool/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage/componentList/ButtonComponent",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__componentList__ButtonComponent__index' */'@/pages/TenantSettings/CustomizePage/componentList/ButtonComponent/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage/componentList/DoubleButtonComponent/Client",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__componentList__DoubleButtonComponent__Client__index' */'@/pages/TenantSettings/CustomizePage/componentList/DoubleButtonComponent/Client/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage/componentList/DoubleButtonComponent/Tool",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__componentList__DoubleButtonComponent__Tool__index' */'@/pages/TenantSettings/CustomizePage/componentList/DoubleButtonComponent/Tool/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage/componentList/DoubleButtonComponent",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__componentList__DoubleButtonComponent__index' */'@/pages/TenantSettings/CustomizePage/componentList/DoubleButtonComponent/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage/componentList/ImageComponent/Client",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__componentList__ImageComponent__Client__index' */'@/pages/TenantSettings/CustomizePage/componentList/ImageComponent/Client/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage/componentList/ImageComponent/Tool",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__componentList__ImageComponent__Tool__index' */'@/pages/TenantSettings/CustomizePage/componentList/ImageComponent/Tool/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage/componentList/ImageComponent",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__componentList__ImageComponent__index' */'@/pages/TenantSettings/CustomizePage/componentList/ImageComponent/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage/componentList/TextComponent/Client",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__componentList__TextComponent__Client__index' */'@/pages/TenantSettings/CustomizePage/componentList/TextComponent/Client/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage/componentList/TextComponent/Tool",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__componentList__TextComponent__Tool__index' */'@/pages/TenantSettings/CustomizePage/componentList/TextComponent/Tool/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage/componentList/TextComponent",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__componentList__TextComponent__index' */'@/pages/TenantSettings/CustomizePage/componentList/TextComponent/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/CustomizePage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__CustomizePage__index' */'@/pages/TenantSettings/CustomizePage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/common/CustomColorPicker",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__common__CustomColorPicker__index' */'@/pages/TenantSettings/HomepageDecoration/common/CustomColorPicker/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/common/HorizontalDrag",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__common__HorizontalDrag__index' */'@/pages/TenantSettings/HomepageDecoration/common/HorizontalDrag/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/common/LinkComponent",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__common__LinkComponent__index' */'@/pages/TenantSettings/HomepageDecoration/common/LinkComponent/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/BannerSwiper/Client",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__BannerSwiper__Client__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/BannerSwiper/Client/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/BannerSwiper/Tool",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__BannerSwiper__Tool__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/BannerSwiper/Tool/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/BannerSwiper/Widget",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__BannerSwiper__Widget__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/BannerSwiper/Widget/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/BannerSwiper",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__BannerSwiper__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/BannerSwiper/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/CompoundGridBox/Client",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__CompoundGridBox__Client__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/CompoundGridBox/Client/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/CompoundGridBox/Tool",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__CompoundGridBox__Tool__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/CompoundGridBox/Tool/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/CompoundGridBox/Widget",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__CompoundGridBox__Widget__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/CompoundGridBox/Widget/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/CompoundGridBox",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__CompoundGridBox__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/CompoundGridBox/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/HealthInfo/Client",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__HealthInfo__Client__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/HealthInfo/Client/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/HealthInfo/Tool",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__HealthInfo__Tool__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/HealthInfo/Tool/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/HealthInfo/Widget",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__HealthInfo__Widget__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/HealthInfo/Widget/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/HealthInfo",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__HealthInfo__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/HealthInfo/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/HealthPunch/Client",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__HealthPunch__Client__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/HealthPunch/Client/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/HealthPunch/Tool",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__HealthPunch__Tool__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/HealthPunch/Tool/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/HealthPunch/Widget",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__HealthPunch__Widget__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/HealthPunch/Widget/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/HealthPunch",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__HealthPunch__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/HealthPunch/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/SearchInput/Client",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__SearchInput__Client__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/SearchInput/Client/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/SearchInput/Tool",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__SearchInput__Tool__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/SearchInput/Tool/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/SearchInput/Widget",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__SearchInput__Widget__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/SearchInput/Widget/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/SearchInput",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__SearchInput__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/SearchInput/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/SpecialServiceBox/Client",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__SpecialServiceBox__Client__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/SpecialServiceBox/Client/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/SpecialServiceBox/Tool",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__SpecialServiceBox__Tool__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/SpecialServiceBox/Tool/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/SpecialServiceBox/Widget",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__SpecialServiceBox__Widget__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/SpecialServiceBox/Widget/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/SpecialServiceBox",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__SpecialServiceBox__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/SpecialServiceBox/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/TopNavbar/Client",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__TopNavbar__Client__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/TopNavbar/Client/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/TopNavbar/Tool",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__TopNavbar__Tool__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/TopNavbar/Tool/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration/componentList/TopNavbar",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__componentList__TopNavbar__index' */'@/pages/TenantSettings/HomepageDecoration/componentList/TopNavbar/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/HomepageDecoration",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__HomepageDecoration__index' */'@/pages/TenantSettings/HomepageDecoration/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/OrgManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__OrgManage__index' */'@/pages/TenantSettings/OrgManage/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/TenantSettings/Setting",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TenantSettings__Setting__index' */'@/pages/TenantSettings/Setting/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/User/login",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__User__login__index' */'@/pages/User/login/index.tsx'), loading: LoadingComponent}),
        "layout": false
      },
      {
        "path": "/WechatMp/Autoreply/DefaultReply",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__WechatMp__Autoreply__DefaultReply__index' */'@/pages/WechatMp/Autoreply/DefaultReply/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/WechatMp/Autoreply/KeywordReply",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__WechatMp__Autoreply__KeywordReply__index' */'@/pages/WechatMp/Autoreply/KeywordReply/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/WechatMp/Autoreply",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__WechatMp__Autoreply__index' */'@/pages/WechatMp/Autoreply/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/WechatMp/BindMa",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__WechatMp__BindMa__index' */'@/pages/WechatMp/BindMa/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/WechatMp/CustomizeMenus",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__WechatMp__CustomizeMenus__index' */'@/pages/WechatMp/CustomizeMenus/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/Welcome",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Welcome' */'@/pages/Welcome.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index' */'@/pages/index.tsx'), loading: LoadingComponent})
      },
      {
        "path": "/noAccess",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__noAccess' */'@/pages/noAccess.tsx'), loading: LoadingComponent})
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'@/pages/404.tsx'), loading: LoadingComponent})
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
